import { Button, Modal, ModalHeader } from '@mairistem/composants';
import type { JournalBordereau } from '@mairistem/comptabilite';
import React from 'react';
import BordereauEtat from '../../../../../constants/liquidation/bordereaux/BordereauEtat';
import useModalSuperUserValidation from '../../../../../hooks/useModalSuperUserValidation';
import type { BordereauWithState } from '../../../../../interfaces/pieces/TreeRow';

interface RelancerFluxModalProps {
	onChange: (data: BordereauWithState) => void;
	onClose: VoidFunction;
	bordereau: BordereauWithState;
	visible: boolean;
	isSuperUser: boolean;
}

const RelancerFluxBordereauModal = ({
	onChange,
	onClose,
	bordereau,
	visible,
	isSuperUser,
}: RelancerFluxModalProps) => {
	const { isValidated, validationComponent } = useModalSuperUserValidation();

	const lastJournalPES: JournalBordereau | null = bordereau.journauxBordereau
		.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
		.find(
			(journal) => journal.etat === BordereauEtat.TRAITEMENT_PES_EN_INSTANCE,
		);

	return (
		<Modal
			open={visible}
			onClose={onClose}
			closeIcon
			data-testid="relancerFluxModal"
		>
			<ModalHeader>
				Relancer le flux PES du bordereau n°
				{bordereau.numero}
			</ModalHeader>
			<Modal.Content>
				<p>
					{!lastJournalPES ? (
						"Êtes-vous sûr de vous relancer l'émission du flux PES ?"
					) : (
						<>
							Ce bordereau fait l’objet d’un traitement PES effectué par{' '}
							{lastJournalPES?.utilisateur?.prenom}{' '}
							{lastJournalPES?.utilisateur?.nom} le{' '}
							{new Date(lastJournalPES?.date).toLocaleString('fr-FR', {
								year: 'numeric',
								month: '2-digit',
								day: '2-digit',
							})}
							{' à '}
							{new Date(lastJournalPES?.date).toLocaleString('fr-FR', {
								hour: '2-digit',
								minute: '2-digit',
							})}
						</>
					)}
				</p>
				{isSuperUser && validationComponent}
			</Modal.Content>
			<Modal.Actions>
				<Button
					onClick={onClose}
					data-testid="relancerFluxBordereauModalCancel"
				>
					Annuler
				</Button>
				<Button
					disabled={isSuperUser && !isValidated}
					primary
					onClick={() => {
						onChange(bordereau);
						onClose();
					}}
					data-testid="relancerFluxBordereauModalConfirm"
				>
					Confirmer
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default RelancerFluxBordereauModal;
